module.exports = __webpack_public_path__ + "static/CCQ-05-f6bb75efad582fc64215d59cd015f8f5.jpg";